import React, { Component } from 'react'
import Router from '../route/router'

export class Main extends Component {
  render() {
    return (
      <main className="main">
        <Router />
      </main>
    )
  }
}

export default Main
